import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'No tengo tiempo para cocinar recetas elaboradas',
    a: 'Todas las recetas están pensadas para menos de 30 minutos. Muchas se congelan y se pueden preparar en lotes.'
  }, {
    q: 'Mi hijo es muy selectivo, no va a comer esto',
    a: 'NutriPeques parte de esa realidad. La guía incluye estrategias específicas y psicología del comportamiento para niños selectivos.'
  }, {
    q: 'Ya tengo muchos libros de recetas',
    a: 'NutriPeques no es solo recetas. Es un sistema de organización + psicología del comportamiento en la mesa para acabar con las peleas.'
  }, {
    q: '¿Funciona para bebés menores de 1 año?',
    a: 'El recetario está diseñado para 1 a 7 años. Para bebés en inicio de alimentación complementaria, no es el recurso adecuado.'
  }, {
    q: '¿Necesito ingredientes especiales o costosos?',
    a: 'No. Todas las recetas usan ingredientes reales y accesibles que encuentras en cualquier supermercado.'
  }, {
    q: '¿Y si no me funciona?',
    a: 'Tienes 30 días de garantía total. Sin preguntas. Te devolvemos el 100% de tu dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" data-id="element-199" data-mp="20om6aym3e5ne">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-200" data-mp="20mri9bfixxf3">
        <div className="text-center mb-12" data-id="element-201" data-mp="2fcpb44oefbam">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-202" data-mp="2ffux3b1qdx24">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-[#FFCC80] mx-auto rounded-full" data-id="element-203" data-mp="2oe6mxaurwqti"></div>
        </div>

        <div className="space-y-4" data-id="element-204" data-mp="2jfc5ac8jl8az">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-2xl overflow-hidden bg-[#FDFBF7]" data-id="element-205" data-mp="2jfvhdcbih2h3" data-mpi={idx}>
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex justify-between items-center p-5 text-left focus:outline-none" data-id="element-206" data-mp="u0nu2ebotwej">
                <span className="font-bold text-gray-900 pr-4" data-id="element-207" data-mp="2p4lvrvnz7whd">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-208" data-mp="2u25aewol6b9u" />
              </button>
              <AnimatePresence data-id="element-209" data-mp="2z44anxp14s2k">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-210" data-mp="3344q9lnv79b7">
                    <div className="p-5 pt-0 text-gray-600 border-t border-gray-100" data-id="element-211" data-mp="3ht17a87wfwny">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}